import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var UploadIcon = function UploadIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "UploadIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1 1.913C1 1.409 1.409 1 1.913 1h12.174a.913.913 0 0 1 0 1.826H1.913A.913.913 0 0 1 1 1.913m7.913 6.262 2.5 2.5a.913.913 0 1 0 1.29-1.292L9.22 5.9l-.016-.016a5 5 0 0 0-.28-.265 1.4 1.4 0 0 0-.485-.28 1.42 1.42 0 0 0-.878 0c-.218.07-.377.189-.485.28-.094.08-.193.18-.28.265L6.78 5.9 3.297 9.383a.913.913 0 1 0 1.292 1.292l2.499-2.5v5.912a.913.913 0 0 0 1.826 0z",
      clipRule: "evenodd"
    })
  }));
};

export { UploadIcon };
